import _ from 'lodash';

function HealthCtrl($scope, $rootScope, $state, $stateParams, toastr, AuthService, BioService, AppContextService, DashboardService, PlanService, $ngConfirm) {
  'ngInject';


  const vm = this;
  vm.appContext = AppContextService.context;

  if ($stateParams.tab) {
    vm.tab = $stateParams.tab;
  } else {
    vm.tab = 'daily';
  }

  if (vm.appContext.role2 === 'player') {
    $state.go('Service.healthDetail', { user_id: vm.appContext.user.user_id});
    return;
  }

  vm.video = {
    title: '',
    url: ''
  };

  vm.content = {
    title: '',
    subtitle: '수면',
    type: 'url',
    url: ''
  };

  var dailyItems = ['bodyheat', 'height'],
    dailySuffixes = ['_target', ''];
  var deviceItems = ['DS', 'VL', 'SP', 'AC', 'HB', 'OS', 'LA', 'BT2'],
    deviceSuffixes = [''];

  var dataList = function (fromDate, toDate) {
    var params = {
      'login_id': vm.appContext.user.login_id,
      'uuid': vm.appContext.user.uuid,
      'date': toDate || moment().format("YYYY.MM.DD"),
      'from_date': fromDate || '2000.01.01'
    };

    // 전체관리자가 선택한 team_id
    if ($stateParams.manager_admin_team_id) {
      params.team_id = $stateParams.manager_admin_team_id;
    }

    vm.playersBioInfo = [];
    BioService.healthDataList(params).then(function (res) {
      console.log(res.data)
      // console.log('배열크기..', res.data.data.length)
      var bios = res.data.data;
      for (var i=0; i<bios.length; i++) {
        // console.log(bios[i].current)
        vm.playersBioInfo[i] = {};

        (function(i) {
          var dates = [];
          _.forEach(bios[i].history, function(item) {
            _.forEach(item.records, function(item2) {
              dates.push(+(item2.date.replace(/\./g, '')));
            });
          });

          if (dates.length) {
            var tempDate = '' + _.max(dates);
            tempDate = tempDate.substr(0, 4) + '.' + tempDate.substr(4, 2) + '.' + tempDate.substr(6, 2);
            var userData2Date = tempDate;
          }

          var userData2Params = {
            user_id: bios[i].user_id
          };
          if (userData2Date) {
            userData2Params.day = userData2Date.replace(/\./g, '');
            userData2Params.date = userData2Date;
          }

          (function(userData2Params, i) {
            setTimeout(function() {
              BioService.userData2(userData2Params).then(function(res2) {
                _.forEach(res2.data.list, function(item) {
                  var value,
                    values = [];
    
                  if (item.type === 'CB' || item.type === 'CL') {
                    if (item.current_1 !== '0') {
                      values.push(item.current_1);
                    }
                  } else {
                    if (item.current !== '0' && item.current !== '0.0' && item.current !== '0:00') {
                      values.push(item.current);
                    }
                    if (typeof item.current2 !== 'undefined') {
                      values.push(item.current2);
                    }
                    if (typeof item.current3 !== 'undefined') {
                      values.push(item.current3);
                    }
                    if (typeof item.current4 !== 'undefined') {
                      values.push(item.current4);
                    }
                    if (typeof item.current5 !== 'undefined') {
                      values.push(item.current5);
                    }
                    if (typeof item.current6 !== 'undefined') {
                      values.push(item.current6);
                    }
                  }
                  
                  value = values.join(',');
    
                  bios[i][item.type] = value;
    
                  vm.playersBioInfo[i] = bios[i];
                });

                (function(i) {
                  _.forEach(dailyItems, function(item2, j) {
                    _.forEach(dailySuffixes, function(suffix) {
                      var type = item2 + suffix;

                      (function(i, type) {
                        if ((type !== 'bodyheat' && type !== 'height') || !userData2Params.date) {
                          return;
                        }
                        setTimeout(function() {
                          // 데일리 데이터 조회
                          $.ajax({
                            url: 'http://eptsdev.codns.com:7724/manager/get_daily_data',
                            type: 'GET',
                            data: {
                              user_id: userData2Params.user_id,
                              day: userData2Params.date,
                              type: type
                            },
                            success: function(data) {
                              if (data.length) {
                                var dataItem = data[0];
                                vm.playersBioInfo[i][dataItem.type] = dataItem.value;
                                console.log(userData2Params.user_id, userData2Params.date, dataItem.type, dataItem.value);
                              }
                            },
                            error: function(err) {
                              console.log(err);
                            }
                          });
                        }, i * j * 100);
                      })(i, type);
                      
                    });
                  });
                  
                  _.forEach(deviceItems, function(item2, j) {
                    _.forEach(deviceSuffixes, function(suffix) {
                      var type = item2 + suffix;

                      (function(i, type) {
                        if ((type !== 'SP' && type !== 'AC' && type !== 'BT2') || !userData2Params.date) {
                          return;
                        }
                        setTimeout(function() {
                          // 디바이스 데이터 조회
                          $.ajax({
                            url: 'http://eptsdev.codns.com:7724/manager/get_device_data',
                            type: 'GET',
                            data: {
                              user_id: userData2Params.user_id,
                              day: userData2Params.date,
                              type: type
                            },
                            success: function(data) {
                              if (data.length) {
                                var dataItem = data[0];
                                vm.playersBioInfo[i][dataItem.type] = dataItem.value;
                                console.log(userData2Params.user_id, userData2Params.date, dataItem.type, dataItem.value);
                              }
                            },
                            error: function(err) {
                              console.log(err);
                            }
                          });
                        }, i * j * 100);
                      })(i, type);
                      
                    });
                  });
                })(i);
              }).catch(function(err) {
                console.log(err);
              });

              for (var j = 0; j < bios[i].current.length; j++) {
                // console.log(bios[i].current[j].type)
                bios[i][bios[i].current[j].type] = bios[i].current[j].value;
              }
            }, i * 50);
          })(userData2Params, i);
        })(i);

        
      }
      // var data = res.data;
      // vm.playersBioInfo = res.data.data;
      // console.log(bios)
      //vm.playersBioInfo = bios;
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  }
  dataList();

  vm.getPlayerBiometricInfo = dataList;

  var list = function () {
    var data = {
      login_id: vm.appContext.user.login_id,
    };
    DashboardService.list(data)
    .then(function (res) {
      vm.contents = res.data.lists[2].list[0].contents;
      vm.videos = res.data.lists[2].list[0].videos;
      _.forEach(vm.videos,  video => {
          if (video.url.indexOf('?v=') > -1) {
            video.image = 'https://img.youtube.com/vi/' + video.url.split('=')[1] + '/0.jpg';
          } else {
            video.image = 'https://img.youtube.com/vi/' + video.url.substring((video.url).lastIndexOf('/') + 1) + '/0.jpg';
          }
      });


    })
    .catch(function(error) {
      console.log('ERROR : ',  error);
    });
  }
  list();

  vm.set = function (type, is_video) {

    if (is_video === 'N' &&  !vm.content.subtitle) {
      toastr.error('구분을 선택해 주세요. ')
      return;
    }

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      type: type,
      is_video: is_video,
      is_admin: 'N',
      title: is_video === 'Y' ? vm.video.title : vm.content.title,
      subtitle: is_video === 'Y' ? vm.video.subtitle : vm.content.subtitle,
      url: is_video === 'Y' ? vm.video.url : vm.content.url
    };

    if (!data.title) {
      toastr.error('제목을 입력하세요');
      return;
    }

    if (!data.subtitle) {
      toastr.error('구분을 선택하세요');
      return;
    }

    if (!data.url) {
      toastr.error('url을 입력하세요');
      return;
    }


    DashboardService.set(data).then(function (res) {
      list();
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  }

  vm.recommendedVideos = [];
  
  vm.isFirstSearch = true;
  var footballArr = ['football', 'football', 'football', 'soccer', 'soccer', 'futsal']; // 검색결과가 다양하게 나오게 하기 위한 처리, football, soccer 에 가중치를 줌
  
  // 영상 구분을 선택하면 영상 추천
  $scope.$watch('vm.video.subtitle', function (newVal, oldVal) {
    var container = $('#health-recommend-results');

    if (!newVal) {
      container.html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">영상 등록에서 구분을 선택해주십시오</li>');
    } else {
      var keyword = newVal;
      if (keyword === '소모' || keyword === '섭취') {
        keyword = '칼로리 ' + keyword;
      }

      container.html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">추천 영상을 조회중입니다.</li>');
      var q = (vm.isFirstSearch ? 'football' : footballArr[Math.floor(Math.random() * footballArr.length)]) + ' health ' + newVal;
      var params = {
        q: q,
        part: 'snippet', 
        maxResults: 5,
        pageToken: 'CAoQAA' // 조회할 때마다 다른 결과가 조회되게 하기 위해 - https://developers.google.com/youtube/v3/guides/implementation/pagination
      };
      
      PlanService.getVideoRecommend(params)
        .then(function(res) {
          container.empty();
          var srchItems = res.items,
            videos = [];
          $.each(srchItems, function(index, item) {
            if  (item.id.kind === 'youtube#video') {
              videos.push({
                id: item.id.videoId,
                title: item.snippet.title,
                url: 'https://youtube.com/watch?v='  +  item.id.videoId
              });

              var vidThumburl =  item.snippet.thumbnails.default.url;                 
              var vidThumbimg = '<div style="position:absolute; top:0; left:0; width:160px; height:120px;"><img id="thumb" src="'+vidThumburl+'" alt="No  Image  Available." style="width:160px;"></div>';
              var vidTitle = '<div style="position:relative; padding-top:10px; margin-left:170px; width:calc(100% - 200px); font-size:14px;">' + item.snippet.title + '<div style="margin-top:20px; text-align:center;"><a href="#" class="play-video" style="text-decoration:none; color:#4CAF50;" data-id="' + item.id.videoId + '">[영상보기]</a><a href="#" class="select-video" style="margin-left:20px; text-decoration:none; color:#2196F3;" data-url="https://youtube.com/watch?v=' + item.id.videoId + '" data-title="' + item.snippet.title + '">[영상선택]</a></div></div>';  

              container.append('<li style="position:relative; margin:0 0 10px 0; padding:0; min-height:120px;">' + vidThumbimg + vidTitle + '</li>');                      
            }
          });

          vm.recommendedVideos = videos;

          vm.isFirstSearch = false;
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  });

  // 추천영상 보기
  $('body').off('click.selectVideo').on('click.playVideo', '.play-video', function(e) {
    e.preventDefault();

    var anchor = $(this);
    document.getElementById('recommended_video').style.display = 'block';

    $scope.$apply(function () {
      vm.recommendedVideo = _.find(vm.recommendedVideos, {
        id: anchor.data('id')
      });
    });
  });

  // 추천영상 선택
  $('body').off('click.selectVideo').on('click.selectVideo', '.select-video', function(e) {
    e.preventDefault();

    var anchor = $(this);

    $scope.$apply(function () {
      vm.video.url = anchor.data('url');
      vm.video.title = anchor.data('title');
    });

    toastr.success('영상이 선택되었습니다.');
  });

  vm.remove = function (id) {

    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            var data = {
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              id: id
            };
            DashboardService.remove(data).then(function (res) {
              list();
            }).catch(function (e) {
              console.log('ERROR ' + e);
            });


          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
          // action: function (scope, button) {
          // }
        },
      }
    });


  }

  vm.go = function(url) {
    window.open(url, '_blank'); 
  }

  vm.updateTab = function(tab) {
    $state.transitionTo('Service.health', {tab: tab}, {
      location: true,
      inherit: true,
      relative: $state.$current,
      notify: false
    });
  };

  $scope.$on('youtube.player.ready', function ($event, player) {
    $rootScope.YTPlayer = player;
  });

  // 역량검색, 부상검색, 훈련검색, 경기검색
  vm.contentSearch = function() {
    var container = $('#health-recommend-results');

    if (!newVal) {
      container.html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">영상 등록에서 구분을 선택해주십시오</li>');
    } else {
      var keyword = newVal;
      if (keyword === '소모' || keyword === '섭취') {
        keyword = '칼로리 ' + keyword;
      }

      container.html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">추천 영상을 조회중입니다.</li>');
      var q = (vm.isFirstSearch ? 'football' : footballArr[Math.floor(Math.random() * footballArr.length)]) + ' health ' + newVal;
      var params = {
        q: q,
        part: 'snippet', 
        maxResults: 5,
        pageToken: 'CAoQAA' // 조회할 때마다 다른 결과가 조회되게 하기 위해 - https://developers.google.com/youtube/v3/guides/implementation/pagination
      };
      
      PlanService.getVideoRecommend(params)
        .then(function(res) {
          container.empty();
          var srchItems = res.items,
            videos = [];
          $.each(srchItems, function(index, item) {
            if  (item.id.kind === 'youtube#video') {
              videos.push({
                id: item.id.videoId,
                title: item.snippet.title,
                url: 'https://youtube.com/watch?v='  +  item.id.videoId
              });

              var vidThumburl =  item.snippet.thumbnails.default.url;                 
              var vidThumbimg = '<div style="position:absolute; top:0; left:0; width:160px; height:120px;"><img id="thumb" src="'+vidThumburl+'" alt="No  Image  Available." style="width:160px;"></div>';
              var vidTitle = '<div style="position:relative; padding-top:10px; margin-left:170px; width:calc(100% - 200px); font-size:14px;">' + item.snippet.title + '<div style="margin-top:20px; text-align:center;"><a href="#" class="play-video" style="text-decoration:none; color:#4CAF50;" data-id="' + item.id.videoId + '">[영상보기]</a><a href="#" class="select-video" style="margin-left:20px; text-decoration:none; color:#2196F3;" data-url="https://youtube.com/watch?v=' + item.id.videoId + '" data-title="' + item.snippet.title + '">[영상선택]</a></div></div>';  

              container.append('<li style="position:relative; margin:0 0 10px 0; padding:0; min-height:120px;">' + vidThumbimg + vidTitle + '</li>');                      
            }
          });

          vm.recommendedVideos = videos;

          vm.isFirstSearch = false;
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  };


}

export default {
  name: 'HealthCtrl',
  fn: HealthCtrl
};
